import { useCreateResumeStore } from "../store/CreateResumeStore";
import { locale } from "./locale.js";

const createResumeStore = useCreateResumeStore();

export default function t(key) {
  return locale[createResumeStore.selectedLanguage][key];
}
